/** Base path for admin UI when embedded (e.g. iframes on client sites). */
export const ADMIN_EMBED_PREFIX = "/admin";

export function isAdminEmbedPath(pathname) {
  if (!pathname) return false;
  return pathname === "/admin" || pathname.startsWith("/admin/");
}

/**
 * Sidebar items use absolute paths like `/home`. When the shell is under `/admin/*`,
 * navigation targets must be prefixed so the URL stays in the embed tree.
 */
export function resolveAdminNavTo(pathname, to) {
  if (!to) return to;
  if (isAdminEmbedPath(pathname)) {
    return `${ADMIN_EMBED_PREFIX}${to}`;
  }
  return to;
}

/**
 * Strip `/admin` for comparisons against PARTNER_FILTERED_ROUTES (which use non-prefixed paths).
 */
export function canonicalPathForPartnerChip(pathname) {
  if (!pathname || !isAdminEmbedPath(pathname)) return pathname;
  if (pathname === "/admin" || pathname === "/admin/") return "/";
  const rest = pathname.slice(ADMIN_EMBED_PREFIX.length);
  return rest && rest.startsWith("/") ? rest : `/${rest}`;
}

/** Prefix an in-app path when the shell is under `/admin` (e.g. programmatic `navigate`). */
export function withAdminEmbedPrefix(pathname, path) {
  if (!path || !isAdminEmbedPath(pathname)) return path;
  return path.startsWith(ADMIN_EMBED_PREFIX) ? path : `${ADMIN_EMBED_PREFIX}${path}`;
}
